import React from "react";

type MomentumPillProps = {
  momentum?: string | null;
};

function MomentumPill({ momentum }: MomentumPillProps) {
  const label = momentum || "—";
  const lower = label.toLowerCase();

  let color = "bg-slate-100 text-slate-600 border-slate-200";
  if (lower === "hot")
    color = "bg-rose-50 text-rose-700 border-rose-100";
  if (lower === "warm")
    color = "bg-amber-50 text-amber-700 border-amber-100";
  if (lower === "cold")
    color = "bg-slate-100 text-slate-500 border-slate-200";

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${color}`}
    >
      {label}
    </span>
  );
}

export default MomentumPill;
